import React from "react";
import { FieldValidationErrorMsg, RequiredAsterisk } from "../atoms/form";

/**
 * InputTextSingleColumn component represents a text input field with a label, placeholder, and validation error message,
 * displayed in a single column form layout.
 * 
 * @param {Object} props - Component props
 * @param {string} props.labelText - The label text for the input field
 * @param {string} props.id - The ID of the input field
 * @param {string} [props.placeholder] - The placeholder text for the input field
 * @param {number} [props.maxlength] - The maximum length allowed for the input field
 * @param {any} props.register - The register function from React Hook Form for registering the input field
 * @param {any} props.errors - The errors object from React Hook Form for displaying validation errors
 * @param {boolean} [props.showIsRequired] - Determines whether to show the asterisk indicating the field is required
 * @returns {JSX.Element} - JSX element representing the InputTextSingleColumn component
 */
export default function InputTextSingleColumn({
  labelText,
  id,
  placeholder,
  maxlength,
  register,
  errors,
  showIsRequired,
}) {
  return (
    <div className="form-group mb-2">
      <label htmlFor={id}>{labelText}</label>
      {showIsRequired && <RequiredAsterisk />}
      <input
        type="text"
        className="form-control"
        id={id}
        placeholder={placeholder}
        maxLength={maxlength}
        {...register(id)}
      />
      <FieldValidationErrorMsg field={id} errors={errors} />
    </div>
  );
}
